import { type ReactElement } from 'react';
import { NeonButtonFooter, NeonModalDialog } from '@ps-refarch-ux/neon';
import { NeonButtonTypes } from '@/constants/neon-constants';
import { BULK_DELETE_MODAL_TEXT } from '@/constants/course-catalog-constants';
import modalStyles from './course-catalog-modals.module.scss';

export interface BulkDeleteCoursesModalProps {
  isOpen: boolean;
  selectedCount: number;
  onConfirm: () => void;
  onClose: () => void;
  isDeleting: boolean;
}

export function BulkDeleteCoursesModal({
  isOpen,
  selectedCount,
  onConfirm,
  onClose,
  isDeleting,
}: BulkDeleteCoursesModalProps): ReactElement | null {
  if (!isOpen) {
    return null;
  }

  const body1 = BULK_DELETE_MODAL_TEXT.getBody1(selectedCount);
  const body2 = BULK_DELETE_MODAL_TEXT.getBody2(selectedCount);

  return (
    <NeonModalDialog id="bulk-delete-courses-modal" neonDialogHasClosed={onClose} dataSize="small">
      <div data-slot="dialog-header-title">{BULK_DELETE_MODAL_TEXT.Title}</div>
      <div data-slot="dialog-body">
        <p className={`__neon__text ${modalStyles.modalBodyText}`}>{body1}</p>
        <p className={`__neon__text ${modalStyles.modalBodyText}`}>{body2}</p>
      </div>
      <div data-slot="dialog-button-footer">
        <NeonButtonFooter
          id="bulk-delete-courses-footer"
          buttons={[
            {
              id: 'bulk-delete-cancel',
              text: BULK_DELETE_MODAL_TEXT.Cancel,
              type: NeonButtonTypes.Borderless,
              onClick: (e): void => {
                (e.target as HTMLElement)?.dispatchEvent(
                  new Event('neonDialogClose', { bubbles: true })
                );
              },
            },
          ]}
          primaryButton={{
            id: 'bulk-delete-confirm',
            text: BULK_DELETE_MODAL_TEXT.Confirm,
            type: NeonButtonTypes.Tertiary,
            disabled: isDeleting,
            onClick: onConfirm,
          }}
        />
      </div>
    </NeonModalDialog>
  );
}
